import { createContext } from "react";
export const DateCalendarContext = createContext({});
